import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import _l from "@/utils/localization";
import { createWorkflowQuery } from "@/components/Panels/utilities";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowSearch',
    setup(__props) {
        const router = useRouter();
        const options = [
            { text: "Yes", value: true },
            { text: "No", value: false },
        ];
        const filterSettings = ref({
            published: false,
            shared_with_me: false,
            deleted: false,
        });
        function onSearch() {
            const query = createWorkflowQuery(filterSettings.value);
            const path = "/workflows/list";
            const routerParams = query ? { path, query: { query } } : { path };
            router.push(routerParams);
        }
        return { __sfc: true, router, options, filterSettings, onSearch, _l };
    }
});
